import { render, staticRenderFns } from "./scanpack.vue?vue&type=template&id=638ace31&scoped=true&"
import script from "./scanpack.vue?vue&type=script&lang=js&"
export * from "./scanpack.vue?vue&type=script&lang=js&"
import style0 from "./scanpack.vue?vue&type=style&index=0&lang=less&"
import style1 from "./scanpack.vue?vue&type=style&index=1&id=638ace31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638ace31",
  null
  
)

export default component.exports